import { Hammer } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";

import type { ServiceSection } from "@/types/sections";

const serviceProjectsSection: ServiceSection = {
  type: SECTION_TYPES.SERVICE_PROJECTS,
  content: {
    header: "Related Projects",
  },
  meta: {
    displayName: "Related Projects",
    displayDescription: "Showcase this service with some photos from your past projects",
    displayIcon: Hammer,
  },
};

export default serviceProjectsSection;
